import type {} from "@lit/react";
import { HorizontalLayout as HorizontalLayoutElement, } from "@vaadin/horizontal-layout/vaadin-horizontal-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { HorizontalLayoutElement, };
export type HorizontalLayoutEventMap = Readonly<{}>;
const events = {} as HorizontalLayoutEventMap;
export type HorizontalLayoutProps = WebComponentProps<HorizontalLayoutElement, HorizontalLayoutEventMap>;
export const HorizontalLayout = createComponent({
    elementClass: HorizontalLayoutElement, events, react: React, tagName: "vaadin-horizontal-layout"
});
